export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "http://localhost:3000",
    backendUrl: "http://localhost:3100",
    appBackendUrl: "http://localhost:4220",
    jsReportUrl: "http://localhost:5488",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://sg-app.heritagekapas.com.my";
    exportResult.backendUrl = "https://sg-api.heritagekapas.com.my/admin";
    exportResult.appBackendUrl = "https://sg-api.heritagekapas.com.my/app";
    exportResult.jsReportUrl = "https://sg-report.heritagekapas.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.appBackendUrl = "https://app-api.travoxis.com";
    exportResult.jsReportUrl = "https://report-test.summerbayresort.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.heritagekapas.com.my";
    exportResult.backendUrl = "https://api.heritagekapas.com.my/admin";
    exportResult.appBackendUrl = "https://api.heritagekapas.com.my/app";
    exportResult.jsReportUrl = "https://report.heritagekapas.com.my";
  }
  return exportResult;
};
